const BaseModel = require('./BaseModel');

class Branding extends BaseModel {
  static basePath = '/api/v1/brandings'; // Brandings are not accessible directly
  static dataType = 'branding';
}

BaseModel.models[Branding.dataType] = Branding;
module.exports = Branding;
